<ion-app>
  <ion-router-outlet mode="ios"></ion-router-outlet>
  <app-offline-indicator></app-offline-indicator>
</ion-app>
